import React from 'react';
import PropTypes from 'prop-types';
import Datatable from '../../../common/datatable';
import {checkPermission} from '../../../common/guards/can';

const columns = [
  {
    title: 'Unique Customer Number',
    prop: 'customer-number',
  },
  {
    title: 'Store Name',
    prop: 'name',
  },
  {
    title: 'RDR',
    prop: 'rdr-code',
  },
  {
    title: 'Reward Eligible?',
    prop: 'reward-eligible',
    format: data => (data ? 'Y' : 'N'),
  },
  {
    title: 'Owner name',
    prop: 'owner',
  },
  {
    title: 'Number of staff',
    prop: 'staff-members',
  },
  {
    title: 'Groups',
    prop: 'groups',
  },
  {
    title: 'Actions',
    prop: 'actions',
    width: '120px',
  }
];

const RepOutletTable = ({
  outlets, paging, currentPage, onPageChange
}) => {
  const {number, size} = paging;
  const dataSize = number * size;
  const pagination = {
    page: currentPage,
    sizePerPage: size,
    onPageChange,
  };

  const tableColumns = columns.filter(column => column.prop !== 'staff-members' || checkPermission('view', 'staff_rep_area'));

  return (
    <div>
      <Datatable
        columns={tableColumns}
        data={outlets}
        dataSize={dataSize}
        pagination={pagination}
        remote
        hideId
      />
    </div>
  );
};

RepOutletTable.propTypes = {
  outlets: PropTypes.array.isRequired,
  paging: PropTypes.shape({
    number: PropTypes.number,
    size: PropTypes.number,
  }),
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default RepOutletTable;



// WEBPACK FOOTER //
// ./src/components/team/my-stores/list/rep-outlet-table.jsx